import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditLogService } from '../../services/audit-log.service';
declare let $: any;

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.css']
})
export class AuditLogsComponent implements OnInit {

    appValues: AppName[] = [
        { value: '1', viewValue: 'LA' },
        { value: '2', viewValue: 'FF' },
        { value: '3', viewValue: 'FN' },
    ];

    auditForm: FormGroup;

    selectedValue: string = '';

    screenNameList:any = [];
    docNoList:any = [];
    auditLogList: any = [];

    docID: any;
    versionLength: any;
    screenValue: any;
    constructor(private router: Router, private route: ActivatedRoute, private service: AuditLogService, private fb: FormBuilder) { }

    ngOnInit(): void {
        $('.my-select').select2();

        this.createForm();

        $('#ddlAppName').on('select2:select', (e, args) => {
            this.screenName($("#ddlAppName").val());
        });

        $('#ddlScreenName').on('select2:select', (e, args) => {
            this.documentNumber($("#ddlScreenName").val());
        });

        $('#ddlDocNo').on('select2:select', (e, args) => {
            this.GetAuditLogDetails($("#ddlDocNo").val());
        });

        $('#ddlVersion').on('select2:select', (e, args) => {
            this.GetAuditLogDetailsPD($("#ddlVersion").val());
        });
    }

    createForm() {
        this.auditForm = this.fb.group({
            selectedValue: 0,
        });
    }

    screenName(event: any) {        
        let payload = {
            "AppName": event.toString(),
        }
        this.service.GetScreenName(payload).subscribe((data: any) => {
            if (data.length > 0) {
                console.log('screenNameList', data);
                this.screenNameList = data;
            }
        });
    }

    documentNumber(event: any) {
        this.screenValue = event.toString();
        let payload = {
            "ScreenName": event.toString(),
        }
        this.service.GetDocumentNumber(payload).subscribe((data: any) => {
            if (data.length > 0) {
                console.log('docNoList', data);
                this.docNoList = data;
            }
        });

        clearTable();
        clearTableOne();
    }

    GetAuditLogDetails(res) {
        this.docID = res;
        let payload = {
            "AffectedID": res,
            "ScreenName": this.screenValue,
        }
        this.service.GetAuditLogDetails(payload).subscribe((data: any) => {
            if (data.length > 0) {
                console.log('GetAuditLogDetails', data);
                this.auditLogList = data;
                this.versionLength = data.length;
                const json = parseXmlToJson(data[this.versionLength - 1].NewData);

                for (const section in json) {
                    const data = json[section];
                    if (Array.isArray(data)) {
                        data.forEach((item, index) => {
                            renderTable(`${section} [${index + 1}]`, item);
                        });
                    } else {
                        renderTable(section, data);
                    }
                }
            }
        });
        clearTable();
        clearTableOne();
    }

    GetAuditLogDetailsPD(res) {
        clearTableOne();
        const json = parseXmlToJson(this.auditLogList[res - 1].NewData);
                for (const section in json) {
                    const data = json[section];
                    if (Array.isArray(data)) {
                        data.forEach((item, index) => {
                            renderTableOne(`${section} [${index + 1}]`, item);
                        });
                    } else {
                        renderTableOne(section, data);
                    }
                }
    }



}
interface AppName {
    value: string;
    viewValue: string;
}

//function parseXmlToJson(xmlString: string): any {
//    function xmlToJson(xml: Element | Document): any {
//        const obj: any = {};
//        if (xml instanceof Element && xml.hasAttributes()) {
//            for (let i = 0; i < xml.attributes.length; i++) {
//                const attr = xml.attributes[i];
//                obj[`@${attr.name}`] = attr.value;
//            }
//        }
//        for (let i = 0; i < xml.childNodes.length; i++) {
//            const node = xml.childNodes[i];
//            if (node.nodeType === Node.ELEMENT_NODE) {
//                const element = node as Element;
//                const nodeName = element.nodeName;
//                const childObject = xmlToJson(element);
//                if (obj[nodeName]) {
//                    if (!Array.isArray(obj[nodeName])) {
//                        obj[nodeName] = [obj[nodeName]];
//                    }
//                    obj[nodeName].push(childObject);
//                } else {
//                    obj[nodeName] = childObject;
//                }
//            } else if (node.nodeType === Node.TEXT_NODE) {
//                const text = node.textContent?.trim();
//                if (text) {
//                    return text;
//                }
//            }
//        }
//        return obj;
//    }

//    const parser = new DOMParser();
//    const xmlDoc = parser.parseFromString(xmlString, "application/xml");
//    return xmlToJson(xmlDoc.documentElement);
//}

//function renderTable(data: Record<string, any>) {
//    const container = document.getElementById("table-container");
//    if (!container) return;

//    const table = document.createElement("table");
//    table.border = "1";
//    table.cellPadding = "8";

//    const tbody = document.createElement("tbody");

//    for (const key in data) {
//        const row = document.createElement("tr");

//        const keyCell = document.createElement("td");
//        keyCell.textContent = key;
//        row.appendChild(keyCell);

//        const valueCell = document.createElement("td");
//        valueCell.textContent = data[key];
//        row.appendChild(valueCell);

//        tbody.appendChild(row);
//    }

//    table.appendChild(tbody);
//    container.innerHTML = ""; // Clear previous
//    container.appendChild(table);
//}

//function renderTableOne(data: Record<string, any>) {
//    const container = document.getElementById("table-containerOne");
//    if (!container) return;

//    const table = document.createElement("table");
//    table.border = "1";
//    table.cellPadding = "8";

//    const tbody = document.createElement("tbody");

//    for (const key in data) {
//        const row = document.createElement("tr");

//        const keyCell = document.createElement("td");
//        keyCell.textContent = key;
//        row.appendChild(keyCell);

//        const valueCell = document.createElement("td");
//        valueCell.textContent = data[key];
//        row.appendChild(valueCell);

//        tbody.appendChild(row);
//    }

//    table.appendChild(tbody);
//    container.innerHTML = ""; // Clear previous
//    container.appendChild(table);
//}

function clearTable() {
    const container = document.getElementById("table-container");
    if (container) {
        container.innerHTML = "";
    }
}
function clearTableOne() {
    const container = document.getElementById("table-containerOne");
    if (container) {
        container.innerHTML = "";
    }
}
function parseXmlToJson(xmlString: string): any {
    function xmlToJson(xml: Element | Document): any {
        const obj: any = {};
        if (xml instanceof Element && xml.hasAttributes()) {
            for (let i = 0; i < xml.attributes.length; i++) {
                const attr = xml.attributes[i];
                obj[`@${attr.name}`] = attr.value;
            }
        }

        for (let i = 0; i < xml.childNodes.length; i++) {
            const node = xml.childNodes[i];
            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as Element;
                const nodeName = element.nodeName;
                const childObject = xmlToJson(element);

                if (obj[nodeName]) {
                    if (!Array.isArray(obj[nodeName])) {
                        obj[nodeName] = [obj[nodeName]];
                    }
                    obj[nodeName].push(childObject);
                } else {
                    obj[nodeName] = childObject;
                }
            } else if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent?.trim();
                if (text) {
                    return text;
                }
            }
        }

        return obj;
    }

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");
    return xmlToJson(xmlDoc.documentElement);
}
function renderTable(title: string, data: Record<string, any>) {
    const container = document.getElementById("table-container");
    if (!container) return;

    const heading = document.createElement("h3");
    heading.textContent = title;
    container.appendChild(heading);

    const table = document.createElement("table");
    table.border = "1";
    table.cellPadding = "6";
    table.style.marginBottom = "16px";
    // Was a fixed 40rem regardless of container size, so this table (in a
    // col-md-6) overflowed past its column into the "Previous Data" table
    // next to it. Fill the column instead.
    table.style.maxWidth = "100%";
    table.style.wordBreak = "break-word";
    table.style.tableLayout = "fixed"; // Ensures uniform column width
    table.style.width = "100%";

    const tbody = document.createElement("tbody");

    for (const key in data) {
        const row = document.createElement("tr");

        const keyCell = document.createElement("td");
        keyCell.textContent = key;
        row.appendChild(keyCell);

        const valueCell = document.createElement("td");
        valueCell.textContent = data[key];
        row.appendChild(valueCell);

        tbody.appendChild(row);
    }

    table.appendChild(tbody);
    container.appendChild(table);
}
function renderTableOne(title: string, data: Record<string, any>) {
    const container = document.getElementById("table-containerOne");
    if (!container) return;

    const heading = document.createElement("h3");
    heading.textContent = title;
    container.appendChild(heading);

    const table = document.createElement("table");
    table.border = "1";
    table.cellPadding = "6";
    table.style.marginBottom = "16px";
    table.style.maxWidth = "100%";
    table.style.wordBreak = "break-word";
    table.style.tableLayout = "fixed"; // Ensures uniform column width
    table.style.width = "100%";

    const tbody = document.createElement("tbody");

    for (const key in data) {
        const row = document.createElement("tr");

        const keyCell = document.createElement("td");
        keyCell.textContent = key;
        row.appendChild(keyCell);

        const valueCell = document.createElement("td");
        valueCell.textContent = data[key];
        row.appendChild(valueCell);

        tbody.appendChild(row);
    }

    table.appendChild(tbody);
    container.appendChild(table);
}
